/**This component is to raise a ticket */

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./RaiseTicket.css";
import { getData } from "../../../Services/ProfileServices";
import { getallBanks, getbarches, getIssueType, getSubIssueType, getResMethods, createGrievance, getThemeURL, grievanceDepartmentslist, getAllSLA, getAllPriority, getAllUserNames } from "../../../Services/EndPoints";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { postDataWithBody, postDataWithFiles } from "../../../Services/Services";
import Modal from "react-bootstrap/Modal";

const RaiseTicket = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isTextFieldDisable } = location.state || {};
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [subject, setSubject] = useState("");
  const [fileErrors, setFileErrors] = useState([]);
  const [userId, setUserId] = useState(null);
  const [branches, setBranches] = useState([]);
  // const [loader, setLoader] = useState(false);
  const [banks, setBanks] = useState([]);
  const [userLevel, setUserLevel] = useState("");
  const [userProfiles, setUserProfiles] = useState([]);
  const [userNames, setUserNames] = useState([]);

  const [formData, setFormData] = useState({
    customerName: "",
    phoneNumber: "",
    email: "",
    resolutionMethodId: "",
    subject: "",
    description: "",
    bankId: "",
    branchId: "",
    issueTypeId: "",
    issueTypeSubCatId: "",
    ticketDateAndTimeString: "",
    resSLADateAndTimeString: "",
    priority: "",
    assignedTeam: "",
    bankName: "",
    branchName: "",
    assignedUser: "",
  });

  // Validation errors 
  const [validationErrors, setValidationErrors] = useState({
    customerName: "",
    phoneNumber: "",
    email: "",
    resolutionMethodId: "",
    subject: "",
    description: "",
    bankId: "",
    branchId: "",
    issueTypeId: "",
    issueTypeSubCatId: "",
    ticketDateAndTimeString: "",
    resSLADateAndTimeString: "",
    priority: "",
    assignedTeam: "",
    bankName: "",
    branchName: "",
    assignedUser: "",
    resolutionDateTime: "",
  });
  const [issueTypes, setIssueTypes] = useState([]);
  const [subIssueTypes, setSubIssueTypes] = useState([]);
  const [resMethods, setResMethods] = useState([]);
  const MAX_LENGTH = 255;
  const [characterCount, setCharacterCount] = useState(0);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [priorityTime, setPriorityTime] = useState([]);
  const [displayTime, setDisplayTime] = useState("");
  const [defaultDateTime, setDefaultDateTime] = useState("");
  const [grievanceType, setGrievanceType] = useState("bank");

  const onEditorStateChange = (editorState) => {
  const plainText = editorState.getCurrentContent().getPlainText();
  const textLength = plainText.length;
 
  // Always update the editor state to allow editing
  setEditorState(editorState);
  setCharacterCount(textLength);
 
  // Always update the form data with current content
  const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
  setFormData({ ...formData, description: html });
 
  // Only set validation error if limit exceeded and form hasn't been submitted yet
  // This allows users to continue typing without constant error messages
  // The final validation will happen on form submit
  if (textLength > MAX_LENGTH) {
    setValidationErrors(prev => ({
      ...prev,
      description: `Maximum length of ${MAX_LENGTH} characters exceeded. Please reduce the content.`
    }));
  } else if (validationErrors.description && textLength <= MAX_LENGTH) {
    // Clear error if within limit and error was previously set
    setValidationErrors(prev => ({
      ...prev,
      description: ""
    }));
  }
};

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setUserId(response[0].id);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const handleSubjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
    setFormData({ ...formData, subject: value });

    if (value) {
      setValidationErrors({ ...validationErrors, subject: "" });
    }
  };

  useEffect(() => {
    getUserProfile();
    fetchAllRoles();
    fetchIssueTypes();
    fetchResolutionMethods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchPriorities = async () => {
      try {
        const response = await getData(getAllSLA);
        if (response && Array.isArray(response)) {
          // Extract unique priorities from the response
          const priorityList = response
            .filter(item => item.activeStatus && !item.is_deleted)
            .map(item => item.priority);
          setPriorities(priorityList);
        }
      } catch (error) {
        console.error("Error fetching priorities:", error);
      }
    };

    fetchPriorities();
  }, []);

  useEffect(() => {
    if (formData.priority) {
      fetchPriorityData(formData.priority);
    }
  }, [formData.priority]);

  // Assuming priorityTime contains the API response like: 
  // { maxResTimeValue: 2, maxResTimeType: "Hours", ... }

  useEffect(() => {
    if (priorityTime && priorityTime.maxResTimeValue && priorityTime.maxResTimeType) {
      const now = new Date();
      const updated = new Date(now);

      const { maxResTimeValue, maxResTimeType } = priorityTime;

      switch (maxResTimeType.toLowerCase()) {
        case "minutes":
          updated.setMinutes(now.getMinutes() + maxResTimeValue);
          break;
        case "hours":
          updated.setHours(now.getHours() + maxResTimeValue);
          break;
        case "days":
          updated.setDate(now.getDate() + maxResTimeValue);
          break;
        default:
          break;
      }

      // Format the result date and time
      const formattedDate = updated.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });

      const formattedTime = updated.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });

      setDisplayTime(`Maximum resolution time: ${maxResTimeValue} ${maxResTimeType} (${formattedDate}, ${formattedTime})`);
    }
  }, [priorityTime]);

  useEffect(() => {
    const date = new Date(); // replace with your actual date value
    setDisplayTime(formatDateTimeForDisplay(date));
  }, []);

  const formatDateTimeCustom = (date) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return `${dd}/${mm}/${yyyy}, ${hours}:${minutes} ${ampm}`;
  };

  const addDaysExcludingSundays = (startDate, daysToAdd) => {
    let resultDate = new Date(startDate);
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      resultDate.setDate(resultDate.getDate() + 1);
      if (resultDate.getDay() !== 0) { // exclude Sundays
        addedDays++;
      }
    }

    return resultDate;
  };

  useEffect(() => {
    if (priorityTime && priorityTime.maxResTimeValue && priorityTime.maxResTimeType) {
      if (priorityTime.maxResTimeType.toLowerCase() === "days") {
        const now = new Date();
        const maxDate = addDaysExcludingSundays(now, priorityTime.maxResTimeValue);
        const formattedDate = formatDateTimeCustom(maxDate);
        setDisplayTime(`Maximum resolution time: ${formattedDate}`);
      }
    }
  }, [priorityTime]);
  const formatDateTimeForDisplay = (date) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
    const yyyy = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 24h to 12h format, with 12 instead of 0

    return `${dd}-${mm}-${yyyy} ${hours}:${minutes} ${ampm}`;
  };

  // Helper function to calculate default date-time excluding Sundays
  const calculateDefaultDateTime = (maxResTimeValue, maxResTimeType) => {
    const currentDate = new Date();

    switch (maxResTimeType) {
      case "Days":
        let daysAdded = 0;
        while (daysAdded < maxResTimeValue) {
          currentDate.setDate(currentDate.getDate() + 1);
          if (currentDate.getDay() !== 0) {
            daysAdded++;
          }
        }
        break;
      case "Hours":
        currentDate.setHours(currentDate.getHours() + maxResTimeValue);
        if (currentDate.getDay() === 0) {
          currentDate.setDate(currentDate.getDate() + 1);
        }
        break;
      case "Minutes":
        currentDate.setMinutes(currentDate.getMinutes() + maxResTimeValue);
        if (currentDate.getDay() === 0) {
          currentDate.setDate(currentDate.getDate() + 1);
        }
        break;
      default:
        break;
    }

    // Add 5 hours 30 minutes for +5:30 offset
    currentDate.setHours(currentDate.getHours() + 5);
    currentDate.setMinutes(currentDate.getMinutes() + 30);

    return currentDate.toISOString().slice(0, 16);
  };


  // When response is received
  useEffect(() => {
    // Use priorityTime instead of undefined responseData
    if (priorityTime && priorityTime.maxResTimeValue && priorityTime.maxResTimeType) {
      const calculatedDateTime = calculateDefaultDateTime(
        priorityTime.maxResTimeValue,
        priorityTime.maxResTimeType
      );
      setDefaultDateTime(calculatedDateTime);
    }
  }, [priorityTime]);

  // Add this function to convert datetime-local format to your required format
  const formatDateTimeForPayload = (dateTimeString) => {
    if (!dateTimeString) return '';

    const date = new Date(dateTimeString);

    // Get date components
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
    const year = date.getFullYear();

    // Get time components
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
    const formattedHours = String(hours).padStart(2, '0');

    return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
  };
  // Extract the date-time from the display message
  const extractDateTime = (displayMessage) => {
    // Match pattern like "15 Minutes (30/10/2025, 10:55 AM)"
    const match = displayMessage.match(/\((\d{2}\/\d{2}\/\d{4}),\s*(\d{1,2}:\d{2}\s*(?:AM|PM))\)/i);

    if (match) {
      const [date, time] = match;
      // Convert from DD/MM/YYYY to DD-MM-YYYY and combine with time
      const formattedDate = date.replace(/\//g, '-');
      return `${formattedDate} ${time}`;
    }
    return null;
  };

  const filteredUsers = userProfiles?.filter(user =>
    user.user_level === "L2" || user.user_level === "L3"
  );

  const fetchAllRoles = async () => {
    // setLoader(true);
    try {
      const rolearr = await getData(grievanceDepartmentslist);
      const sortedRoles = rolearr.sort((a, b) => (a.name > b.name ? 1 : -1));

      const roleList = sortedRoles.map((role) => ({
        label: role.name,
        value: role.id,
      }));

      setRoleList(roleList);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to load roles");
    } finally {
      // setLoader(false);
    }
  };

  const fetchIssueTypes = async () => {
    try {
      let request = ["GRV_CAT_TYPE"]
      const response = await postDataWithBody(getIssueType, request, {})
      if (Array.isArray(response)) {
        setIssueTypes(response);
      }
    } catch (error) {
      console.error("Error fetching issue types:", error);
    }
  }

  const fetchSubIssueTypes = async (issueTypeId) => {
    try {
      const response = await getData(getSubIssueType.replace("ID", issueTypeId));
      if (Array.isArray(response)) {
        setSubIssueTypes(response);
      } else {
        setSubIssueTypes([]);
      }
    } catch (error) {
      console.error("Error fetching sub-issue types:", error);
      setSubIssueTypes([]);
    }
  };

  const fetchPriorityData = async (selectedPriority) => {
    try {
      const response = await getData(getAllPriority.replace("PRIORITY", selectedPriority));
      console.log("Priority response:", response);
      // if (Array.isArray(response)) {
      //   setPriorityTime(response);
      // } else {
      //   setPriorityTime([]);
      // }
      setPriorityTime(response);
    } catch (error) {
      console.error("Error fetching priority data", error);
    }
  };

  const fetchUserNames = async (userLevel) => {
    try {
      const response = await getData(getAllUserNames.replace("USERLEVEL", userLevel));
      console.log("USERLEVEL response:", response);
      setUserNames(response);
    } catch (error) {
      console.error("Error fetching priority data", error);
    }
  };
  useEffect(() => {
    // fetchUserNames(userLevel);
    fetchUserNames("L1");
  }, []);


  const fetchResolutionMethods = async () => {
    try {
      let request = ["GRV_RES_CAT"]
      const response = await postDataWithBody(getResMethods, request, {})
      if (Array.isArray(response)) {
        setResMethods(response);
      }
    } catch (error) {
      console.error("Error fetching resolution methods:", error);
    }
  }


  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      console.log("userProfile", userProfile);
      if (userProfile && userProfile.length > 0) {
        setUserProfiles(userProfile);
        setUserLevel(userProfile[0]?.user_level);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };


  const fetchAllBanks = async () => {
    try {
      const response = await getData(getallBanks);
      if (response && Array.isArray(response)) {
        setBanks(response);
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
    }
  };

  useEffect(() => {
    fetchAllBanks();
  }, []);

  // Add this function after your other handler functions (around line 600)
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "bankName") {
      // Find the selected bank object
      const selectedBank = banks.find(bank => bank.bankName === value);

      if (selectedBank) {
        // Update formData with both bank name and ID
        setFormData({
          ...formData,
          bankName: value,
          bankId: selectedBank.id,
          branchId: "", // Reset branch when bank changes
          branchName: ""
        });

        // Clear validation errors
        setValidationErrors({
          ...validationErrors,
          bankId: "",
          branchId: ""
        });

        // Fetch branches for the selected bank
        fetchBranches(selectedBank.id);
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const fetchBranches = async (bankId) => {
    // setLoader(true);
    try {
      // Replace with your actual endpoint to get branches by bank ID
      const response = await getData(getbarches.replace("ID", bankId));
      if (response && Array.isArray(response)) {
        // Filter branches to only include those matching the selected bankId
        const filteredBranches = response.filter(
          (branch) =>
            branch.bankId === bankId ||
            branch.bankId.toString() === bankId.toString()
        );
        setBranches(filteredBranches);
      } else {
        console.error("Invalid branches data format:", response);
        toast.error("Failed to load branches data");
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
      toast.error("Failed to load branches data");
    } finally {
      // setLoader(false);
    }
    // Return a resolved promise so we can chain with .then()
    return Promise.resolve();
  };


  const handleGrievanceTypeChange = (e) => {
    const selectedType = e.target.value;
    setGrievanceType(selectedType);

    // Clear validation errors when switching types
    setValidationErrors({
      ...validationErrors,
      branchName: "",
      branchId: "",
    });

    // Clear the form fields when switching between types
    if (selectedType === "bank") {
      setFormData({
        ...formData,
        branchName: "",
        branchId: "",
      });
      setBranches([]); // Clear branches list
    } else if (selectedType === "branch") {
      // When switching to branch, keep both fields available
      // You might want to clear or keep the data based on your requirements
      if (formData.bankId) {
        fetchBranches(formData.bankId);
      }
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    let errorMessage = "";
    let updatedValue = value;
    switch (id) {
      case 'customerName':
  if (value && !/^[A-Za-z0-9]+$/.test(value)) {
    errorMessage = 'Requestor User ID can only contain alphanumeric characters';
  } else if (value.length > 0 && value.length < 3) {
    errorMessage = 'Requestor User ID must be at least 3 characters';
  } else if (value.length > 8) {
    errorMessage = 'Requestor User ID cannot exceed 8 characters';
    updatedValue = value.slice(0, 8);
  }
  break;

      case "phoneNumber":
        if (value && !/^\d*$/.test(value)) {
          errorMessage = "Phone number can only contain digits";
          updatedValue = formData.phoneNumber;
        } else if (value.length > 10) {
          errorMessage = "Phone number cannot exceed 10 digits";
          updatedValue = value.slice(0, 10);
        }
        break;

      case "email":
        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          errorMessage = "Please enter a valid email address";
        }
        break;

      case "issueTypeId":
        if (value) {
          fetchSubIssueTypes(value);
        } else {
          setSubIssueTypes([]);
          setFormData({ ...formData, issueTypeSubCatId: "" });
        }
        break;

      case "ticketDateAndTimeString":
        errorMessage = validateDateTime(value);
        break;

      case "resSLADateAndTimeString":
        errorMessage = validateResolutionDateTime(value);
        break;

      case "branchName":
        setFormData({
          ...formData,
          branchName: value,
          branchId: value // Set both for consistency
        });
        setValidationErrors({ ...validationErrors, branchName: errorMessage });
        return; // Early return to avoid the general setFormData call below

      default:
        break;
    }

    setFormData({ ...formData, [id]: updatedValue });
    setValidationErrors({ ...validationErrors, [id]: errorMessage });
  };

  const validateResolutionDateTime = (dateTimeString) => {
  if (!dateTimeString) {
    return "Resolution Date and Time is required when priority time type is Days";
  }

  const selectedDateTime = new Date(dateTimeString);
  const currentDateTime = new Date();

  // Set seconds and milliseconds to 0 for fair comparison
  selectedDateTime.setSeconds(0, 0);
  currentDateTime.setSeconds(0, 0);

  if (selectedDateTime < currentDateTime) {
    return "Resolution Date and Time cannot be in the past. Please choose a valid future date and time.";
  }

  return "";
};

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
    const maxSize = 1 * 1024 * 1024; // 1MB
    const maxFiles = 5;

    const newErrors = [];

    if (selectedImages.length + files.length > maxFiles) {
      newErrors.push(`You can only upload a maximum of ${maxFiles} files.`);
      e.target.value = "";
      setFileErrors(newErrors);
      return;
    }

    const validFiles = [];

    files.forEach((file) => {
      if (!allowedTypes.includes(file.type)) {
        newErrors.push(`File "${file.name}" has an invalid type. Only JPG, PNG, GIF, and PDF are allowed.`);
        return;
      }

      if (file.size > maxSize) {
        newErrors.push(`File "${file.name}" exceeds the 1MB limit.`);
        return;
      }

      validFiles.push(file);
    });

    setFileErrors(newErrors);

    validFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImages((prevImages) => [
          ...prevImages,
          { file, preview: reader.result },
        ]);
      };
      reader.readAsDataURL(file);
    });

    e.target.value = "";
  };

  const removeImage = (indexToRemove) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
  };

  //dd-mm-yyyy formating date
  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = String(date.getFullYear()).toString();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");

    const formattedTime = `${formattedHours}:${minutes} ${ampm}`;

    return `${dd}-${mm}-${yyyy} ${formattedTime}`;
  };

  //form validations
  const validateForm = () => {
    const plainText = editorState.getCurrentContent().getPlainText();
    const textLength = plainText.length;
    const errors = {
      ticketDateAndTimeString: validateDateTime(formData.ticketDateAndTimeString),
      customerName: !formData.customerName 
  ? 'Requestor User ID is required' 
  : formData.customerName.length < 3 
    ? 'Requestor User ID must be at least 3 characters'
    : formData.customerName.length > 8
      ? 'Requestor User ID cannot exceed 8 characters'
      : !/^[A-Za-z0-9]{3,8}$/.test(formData.customerName) 
        ? 'Requestor User ID can only contain alphanumeric characters'
        : '',

      phoneNumber: !formData.phoneNumber
        ? "Requestor Contact Number is required"
        : !/^[6-9]\d{9}$/.test(formData.phoneNumber)
          ? "Requestor Contact Number must start with 6, 7, 8, or 9 and be exactly 10 digits"
          : "",

      email: !formData.email
        ? "Requestor Email Address is required"
        : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
          ? "Please enter a valid email address"
          : "",

      resolutionMethodId: !formData.resolutionMethodId ? "Preferred Resolution Method is required" : "",
      bankId: !formData.bankId ? "Bank Name is required" : "",
      // branchId: !formData.branchId ? "Branch Name is required" : "",
      branchName: (grievanceType === "branch" && !formData.branchId) ? "Branch Name is required" : "",
      issueTypeId: !formData.issueTypeId ? "Category is required" : "",
      issueTypeSubCatId: !formData.issueTypeSubCatId ? "Subcategory is required" : "",
      // ticketDateAndTimeString: !formData.ticketDateAndTimeString ? "Date and Time is required" : "",
      priority: !formData.priority ? "Priority is required" : "",
      assignedTeam: !formData.assignedTeam ? "Assigned Department is required" : "",
      subject: !formData.subject ? "Subject is required" : "",
      description: !editorState.getCurrentContent().hasText()
      ? "Description is required"
      : textLength > MAX_LENGTH
        ? `Maximum length of ${MAX_LENGTH} characters exceeded. Please reduce the content.`
        : "",
      // Add resolution date-time validation when priorityTime type is "Days"
    ...(priorityTime && priorityTime.maxResTimeType === "Days" 
      ? { resolutionDateTime: validateResolutionDateTime(defaultDateTime) }
      : {}),
      ...(userLevel === "L2" || userLevel === "L3"
        ? {
          assignedUser: !formData.assignedUser
            ? "Please select at least one user from the L1 user list"
            : "",
        }
        : {}),
    };

    setValidationErrors(errors);
    return !Object.values(errors).some(error => error !== "");
  };

  //if it is pdf return file type to add pdf icon
  const isPdf = (file) => {
    return file.type === 'application/pdf';
  };

  //date validations
  const validateDateTime = (dateTimeString) => {
    if (!dateTimeString) return "Issue Reported Date & Time is required";

    const selectedDate = new Date(dateTimeString);
    const currentDate = new Date();

    if (isNaN(selectedDate)) return "Invalid date format";

    if (selectedDate > currentDate) {
      return "Date and Time cannot be in the future";
    }

    return "";
  };

  //submit form
  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please fill all mandatory fields correctly", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    const dateError = validateDateTime(formData.ticketDateAndTimeString);
    if (dateError) {
      setValidationErrors(prev => ({
        ...prev,
        ticketDateAndTimeString: dateError
      }));
      toast.error(dateError, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    if (priorityTime && priorityTime.maxResTimeType === "Days") {
    const resolutionDateError = validateResolutionDateTime(defaultDateTime);
    if (resolutionDateError) {
      setValidationErrors(prev => ({
        ...prev,
        resolutionDateTime: resolutionDateError
      }));
      toast.error(resolutionDateError, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }
  }

    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      let resolutionDateTime;
      console.log("priorityTime", resolutionDateTime);
      if (priorityTime && priorityTime.maxResTimeType === "Days" && defaultDateTime) {
        // If Days type and user has selected a custom date-time, use the selected one
        resolutionDateTime = formatDateTimeForPayload(defaultDateTime);
      } else {
        // Otherwise, extract from displayTime or use the calculated maximum resolution time
        const extractedDateTime = extractDateTime(displayTime);
        resolutionDateTime = extractedDateTime || formatDateTimeForPayload(defaultDateTime);
      }

      const grievanceData = {
        customerName: formData.customerName,
        phoneNumber: formData.phoneNumber,
        email: formData.email,
        resolutionMethodId: parseInt(formData.resolutionMethodId),
        bankId: parseInt(formData.bankId),
        branchId: parseInt(formData.branchId),
        issueTypeId: parseInt(formData.issueTypeId),
        issueTypeSubCatId: parseInt(formData.issueTypeSubCatId),
        ticketDateAndTimeString: formatDateTime(formData.ticketDateAndTimeString),
        resSLADateAndTimeString: formatDateTimeForPayload(defaultDateTime),
        priority: formData.priority,
        assignedTeam: formData.assignedTeam,
        description: formData.description,
        subject: formData.subject,
        is_deleted: false,
        createdBy: userLevel === "L1" ? userId : formData.assignedUser,
        is_bank: grievanceType === "bank",
        is_branch: grievanceType === "branch",
        userLevel: "L1",
        // userLevel: userLevel,
        // assignedUser: formData.assignedUser,
      };

      formDataToSend.append('grievance', JSON.stringify(grievanceData));

      // Add all files to a single 'files' array - FIXED APPROACH
      if (selectedImages && selectedImages.length > 0) {
        selectedImages.forEach((imgObj) => {
          if (imgObj.file instanceof File) {
            formDataToSend.append('files', imgObj.file); // This creates an array automatically
          }
        });
      } else {
        // If no files are available, send empty blob for API compatibility
        const emptyBlob = new Blob([], { type: "application/octet-stream" });
        formDataToSend.append("files", emptyBlob, "empty.bin");
      }

      const response = await postDataWithFiles(createGrievance, formDataToSend);

      if (response.status === "success") {
        toast.success(response.msg || "Grievance submitted successfully!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        // navigate(-1);
        navigate("../grievance");
      } else {
        throw new Error(response.msg || 'Failed to submit grievance');
      }

    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Failed to submit grievance", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const getCurrentDateTimeLocal = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const handleCancelClick = () => {
    setShowCancelModal(true);
  };

  //cancel button it will clear all the entered data
  const handleConfirmCancel = () => {


    // Form data state
    setFormData({
      customerName: "",
      phoneNumber: "",
      email: "",
      resolutionMethodId: "",
      subject: "",
      description: "",
      bankId: "",
      branchId: "",
      issueTypeId: "",
      issueTypeSubCatId: "",
      ticketDateAndTimeString: "",
      priority: "",
      assignedTeam: "",
    });
    setValidationErrors({
      customerName: "",
      phoneNumber: "",
      email: "",
      resolutionMethodId: "",
      subject: "",
      description: "",
      bankId: "",
      branchId: "",
      issueTypeId: "",
      issueTypeSubCatId: "",
      ticketDateAndTimeString: "",
      priority: "",
      assignedTeam: "",
    });

    setShowCancelModal(false);

  };

  return (
    <>
      <div className="main-container mt-4">

        {/* Customer Information Section */}
        <h6 className="mb-3" style={{
          color: '#1a7a73',
          fontWeight: 600
        }}>
          Requestor Information
        </h6>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="customerName" className="form-label">
              Requestor User ID<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control branch-input-form-control ${validationErrors.customerName ? "is-invalid" : ""}`}
              id="customerName"
              value={formData.customerName}
              onChange={handleInputChange}
              maxLength={50}
            />
            {validationErrors.customerName && (
              <div className="invalid-feedback">
                {validationErrors.customerName}
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="phoneNumber" className="form-label">
              Requestor Contact Number<span className="text-danger">*</span>
            </label>
            <input
              type="tel"
              className={`form-control branch-input-form-control ${validationErrors.phoneNumber ? "is-invalid" : ""}`}
              id="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              maxLength={15}
            />
            {validationErrors.phoneNumber && (
              <div className="invalid-feedback">
                {validationErrors.phoneNumber}
              </div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="email" className="form-label">
              Requestor Email Address<span className="text-danger">*</span>
            </label>
            <input
              type="email"
              className={`form-control branch-input-form-control ${validationErrors.email ? "is-invalid" : ""}`}
              id="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="example@domain.com"
            />
            {validationErrors.email && (
              <div className="invalid-feedback">
                {validationErrors.email}
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="resolutionMethodId" className="form-label">
              Preferred Resolution Method<span className="text-danger">*</span>
            </label>
            <select
              className={`form-select branch-input-form-control ${validationErrors.resolutionMethodId ? "is-invalid" : ""}`}
              id="resolutionMethodId"
              value={formData.resolutionMethodId}
              onChange={handleInputChange}
            >
              <option value="">Select Resolution Method</option>
              {resMethods.map((resMethod) => (
                <option key={resMethod.id} value={resMethod.id}>
                  {resMethod.value}
                </option>
              ))}
            </select>
            {validationErrors.resolutionMethodId && (
              <div className="invalid-feedback">
                {validationErrors.resolutionMethodId}
              </div>
            )}
          </div>
        </div>

        {/* Grievance Information Section */}
        <div className="col-12 mb-3">
          <label className="form-label">
            Ticket Raised For<span className="text-danger">*</span>
          </label>
          <div className="d-flex gap-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="grievanceType"
                id="bankGrievance"
                value="bank"
                checked={grievanceType === "bank"}
                onChange={handleGrievanceTypeChange}
              />
              <label className="form-check-label" htmlFor="bankGrievance">
                Bank Level Grievance
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="grievanceType"
                id="branchGrievance"
                value="branch"
                checked={grievanceType === "branch"}
                onChange={handleGrievanceTypeChange}
              />
              <label className="form-check-label" htmlFor="branchGrievance">
                Branch Level Grievance
              </label>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div className="col-md-6">
  <label htmlFor="bankName" className="form-label">
    Bank Name<span className="text-danger">*</span>
  </label>

  <select
    id="bankName"
    name="bankName"
    className={`form-select branch-input-form-control ${validationErrors.bankId ? "is-invalid" : ""}`}
    value={formData.bankName}
    onChange={handleChange}
    required
  >
    <option value="">Select Bank</option>
    {banks.map((bank) => (
      <option key={bank.id} value={bank.bankName}>
        {bank.bankName}
      </option>
    ))}
  </select>
  
  {/* Add this error display */}
  {validationErrors.bankId && (
    <div className="invalid-feedback">
      {validationErrors.bankId}
    </div>
  )}
</div>


          <div className="col-md-6">
            <label htmlFor="branchName" className="form-label">
              Branch Name
              {grievanceType === "branch" && <span className="text-danger">*</span>}
            </label>
            <select
              className={`form-control branch-input-form-control ${validationErrors.branchName ? "is-invalid" : ""
                }`}
              id="branchName"
              value={formData.branchName}
              onChange={handleInputChange}
              disabled={grievanceType === "bank"} // Disable when bank is selected
            >
              <option value="" disabled>
                {grievanceType === "bank"
                  ? ""
                  : formData.bankName
                    ? "Select Branch"
                    : "Please select a bank first"
                }
              </option>
              {branches.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.branchName}
                </option>
              ))}
            </select>
            {validationErrors.branchName && (
              <div className="invalid-feedback">
                {validationErrors.branchName}
              </div>
            )}

          </div>
        </div>


        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="issueTypeId" className="form-label">
              Category<span className="text-danger">*</span>
            </label>
            <select
              className={`form-select branch-input-form-control ${validationErrors.issueTypeId ? "is-invalid" : ""}`}
              id="issueTypeId"
              value={formData.issueTypeId}
              onChange={handleInputChange}
            >
              <option value="">Select Category</option>
              {issueTypes.map((issue) => (
                <option key={issue.id} value={issue.id}>
                  {issue.value}
                </option>
              ))}
            </select>
            {validationErrors.issueTypeId && (
              <div className="invalid-feedback">
                {validationErrors.issueTypeId}
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="issueTypeSubCatId" className="form-label">
              Subcategory<span className="text-danger">*</span>
            </label>
            <select
              className={`form-select branch-input-form-control ${validationErrors.issueTypeSubCatId ? "is-invalid" : ""}`}
              id="issueTypeSubCatId"
              value={formData.issueTypeSubCatId}
              onChange={handleInputChange}
            >
              <option value="">Select Subcategory</option>
              {subIssueTypes.map((subIssue) => (
                <option key={subIssue.id} value={subIssue.id}>
                  {subIssue.value}
                </option>
              ))}
            </select>
            {validationErrors.issueTypeSubCatId && (
              <div className="invalid-feedback">
                {validationErrors.issueTypeSubCatId}
              </div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="ticketDateAndTimeString" className="form-label">
              Issue Reported Date & Time<span className="text-danger">*</span>
            </label>
            <input
              type="datetime-local"
              className={`form-control branch-input-form-control ${validationErrors.ticketDateAndTimeString ? "is-invalid" : ""}`}
              id="ticketDateAndTimeString"
              value={formData.ticketDateAndTimeString}
              onChange={handleInputChange}
              max={getCurrentDateTimeLocal()}
              style={{
        backgroundPosition: "right 2.3rem center", // 👈 moves the red "!" slightly left
      }}
            />
            {validationErrors.ticketDateAndTimeString && (
              <div className="invalid-feedback">
                {validationErrors.ticketDateAndTimeString}
              </div>
            )}
          </div>

          <div className="col-md-3">
            <label htmlFor="priority" className="form-label">
              Priority<span className="text-danger">*</span>
            </label>
            <select
              className={`form-control branch-input-form-control ${validationErrors.priority ? "is-invalid" : ""}`}
              id="priority"
              value={formData.priority}
              onChange={(e) => {
                const selectedPriority = e.target.value;
                setFormData({ ...formData, priority: selectedPriority });
                setValidationErrors({ ...validationErrors, priority: "" });

                // Fetch priority data when priority is selected
                if (selectedPriority) {
                  fetchPriorityData(selectedPriority);
                } else {
                  setPriorityTime([]);
                }
              }}
            >
              <option value="">Select Priority</option>
              {priorities.map((priority, index) => (
                <option key={index} value={priority}>
                  {priority}
                </option>
              ))}
            </select>
            {validationErrors.priority && (
              <div className="invalid-feedback">
                {validationErrors.priority}
              </div>
            )}

            {displayTime && (
              <div style={{ marginTop: '5px', color: '#555', fontSize: '14px' }}>
                {displayTime}
              </div>
            )}
          </div>

          {priorityTime && priorityTime.maxResTimeType === "Days" && (
            <div className="col-md-3">
              <label htmlFor="resSLADateAndTimeString" className="form-label">
                Resolution Date and Time
                {/* <span className="text-danger">*</span> */}
              </label>
              <input
                type="datetime-local"
                className={`form-control branch-input-form-control ${
                validationErrors.resolutionDateTime ? "is-invalid" : ""
              }`}
              style={{
              backgroundPosition: "right 2.3rem center", // 👈 moves the red "!" slightly left
            }}
      id="resSLADateAndTimeString"
      value={defaultDateTime}
      onChange={(e) => {
        const selectedValue = e.target.value;
        setDefaultDateTime(selectedValue);
        
        // Validate and set error
        const error = validateResolutionDateTime(selectedValue);
        setValidationErrors({
          ...validationErrors,
          resolutionDateTime: error
        });
      }}
      min={(() => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
      })()}
    />
    {validationErrors.resolutionDateTime && (
      <div className="invalid-feedback">
        {validationErrors.resolutionDateTime}
      </div>
    )}
            </div>
          )}
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="assignedTeam" className="form-label">
              Assigned Department<span className="text-danger">*</span>
            </label>
            <select
              className={`form-select branch-input-form-control ${validationErrors.assignedTeam ? "is-invalid" : ""}`}
              id="assignedTeam"
              value={formData.assignedTeam}
              onChange={handleInputChange}
            >
              <option value="">Select Department</option>
              {roleList.map((role) => (
                <option key={role.value} value={role.value}>
                  {role.label}
                </option>
              ))}
            </select>
            {validationErrors.assignedTeam && (
              <div className="invalid-feedback">
                {validationErrors.assignedTeam}
              </div>
            )}
          </div>
          {filteredUsers.length > 0 && (
            <div className="col-md-6">
              <label htmlFor="assignedUser" className="form-label">
                L1 User List<span className="text-danger">*</span>
              </label>
              <select
                className={`form-select branch-input-form-control ${validationErrors.assignedUser ? "is-invalid" : ""}`}
                id="assignedUser"
                value={formData.assignedUser || ""}
                onChange={handleInputChange}
              >
                <option value="">Select User</option>
                {userNames.map((user) => (
                  <option key={user.id || user.value} value={user.id || user.value}>
                    {user.first_name && user.last_name
                      ? `${user.first_name} ${user.last_name}`
                      : user.first_name
                        ? user.first_name
                        : user.user_name || user.label
                    }
                  </option>
                  // <option key={user.id || user.value} value={user.user_name || user.value}>
                  //   {user.first_name && user.last_name
                  //     ? `${user.first_name} ${user.last_name} (${user.email || user.user_name})`
                  //     : user.first_name
                  //       ? `${user.first_name} (${user.email || user.user_name})`
                  //       : user.user_name || user.label
                  //   }
                  // </option>
                ))}
              </select>
              {validationErrors.assignedUser && (
                <div className="invalid-feedback">
                  {validationErrors.assignedUser}
                </div>
              )}
              {/* <small className="text-muted">
                Optional: Assign to specific user in the department
              </small> */}
            </div>
          )}
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <label htmlFor="subject" className="form-label">
              Subject<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control branch-input-form-control ${validationErrors.subject ? "is-invalid" : ""}`}
              id="subject"
              value={subject}
              onChange={handleSubjectChange}
              maxLength={100}
            />
            {validationErrors.subject && (
              <div className="invalid-feedback">
                {validationErrors.subject}
              </div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <label htmlFor="description" className="form-label">
              Description<span className="text-danger">*</span>
            </label>
            <div className={`border rounded ${validationErrors.description ? "border-danger" : ""}`}>
              <Editor
                editorState={editorState}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={onEditorStateChange}
                toolbar={{
                  options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'history'],
                  inline: {
                    options: ['bold', 'italic', 'underline', 'strikethrough'],
                  },
                }}
                editorStyle={{ minHeight: '150px', padding: '0 10px' }}
              />
            </div>
            <div className="text-muted small text-end mt-1">
              {characterCount} / 255 characters
            </div>

            {validationErrors.description && (
              <div className="text-danger small">
                {validationErrors.description}
              </div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-12">
            <label htmlFor="attachments" className="form-label d-flex justify-content-between">
              <span>Attachments</span>
              <span className="text-muted">+</span>
            </label>
            <div className="border rounded p-3 text-center" style={{ minHeight: '10px' }}>
              <input
                type="file"
                className="d-none"
                id="attachments"
                onChange={handleImageChange}
                multiple
                accept=".jpg,.jpeg,.png,.gif,.pdf"
              />
              <label htmlFor="attachments" className="mb-0" style={{ cursor: 'pointer' }}>
                <div className="text-muted">Click here to browse</div>
              </label>

              {selectedImages.length > 0 && (
                <div className="mt-3 d-flex flex-wrap">
                  {selectedImages.map((imgObj, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        margin: "5px",
                        display: "inline-block",
                      }}
                    >
                      {isPdf(imgObj.file) ? (
                        <div style={{
                          width: "80px",
                          height: "80px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "4px",
                          border: "1px solid #dee2e6",
                          padding: "5px"
                        }}>
                          <div style={{
                            fontSize: "24px",
                            color: "red"
                          }}>
                            PDF
                          </div>
                          <div style={{
                            fontSize: "10px",
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: "100%"
                          }}>
                            {imgObj.file.name}
                          </div>
                        </div>
                      ) : (
                        <img
                          src={imgObj.preview}
                          alt={`preview-${index}`}
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                            borderRadius: "4px",
                          }}
                        />
                      )}
                      <button
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          color: "black",
                          border: "none",
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#ffffff",
                          boxShadow: "0 0 3px rgba(0,0,0,0.3)"
                        }}
                        title="Remove attachment"
                      >
                        ✖
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <small className="text-muted">
              Allowed formats: JPG, PNG, GIF, PDF (max 1MB each, 5 files maximum)
            </small>
            {fileErrors.length > 0 && (
              <div className="mt-2">
                {fileErrors.map((error, index) => (
                  <div key={index} className="text-danger small">
                    {error}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <button
          className="branch-save-submit-btn btn btn-success"
          onClick={handleSubmit}
          disabled={isSubmitting || isTextFieldDisable}
        >
          {isSubmitting ? "Submitting..." : "Save & Submit"}
        </button>
        <button
          className="branch-next-btn btn btn-primary"
          onClick={handleCancelClick}
          style={{
            marginLeft: '15px'
          }}
        >
          Cancel
        </button>
      </div>

      <ToastContainer />
      <Modal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Would you like to clear the input values?
        </Modal.Body>
        <Modal.Footer>
          <button className="btn" style={{
            backgroundColor: 'lightgray',
            color: '#000',
            marginRight: '10px'
          }} onClick={() => setShowCancelModal(false)}>
            No
          </button>
          <button className="btn" style={{
            backgroundColor: 'green',
            color: '#fff'
          }} onClick={handleConfirmCancel}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RaiseTicket;